module.exports = __webpack_public_path__ + "images/imagebetter6.0c6062f2.png";